import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import { I18nextProvider } from "react-i18next"
import { Flip, ToastContainer } from "react-toastify"

import * as serviceWorker from "./serviceWorker"
import { store, persistor } from "./store"
import i18n from "./config/i18n"
import App from "./App"

const container = document.getElementById("root")
if (!container) {
  throw new Error('Root element with id "root" was not found')
}

const root = createRoot(container)

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <App />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          theme="light"
          transition={Flip}
          toastClassName="tw-text-dark tw-font-sans tw-rounded-xl tw-shadow-lg tw-px-4 tw-py-3"
        />
      </I18nextProvider>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
)
serviceWorker.unregister()
